export default "__VITE_ASSET__CAsYoTTr__"